const exportModalCalendar = {
  exportData: 'Exportar Datos',
  excel: 'HOJA DE CÁLCULO (.XLSX)',
};

export default exportModalCalendar;
